import { refusalMessage } from '../lib/acceptance'
import { markErrorShown } from '../lib/feedback'
import { ErrorBox } from './DataTable'

// A refusal that is an answer rather than a failure: a signature this person
// may not give, a request that cannot count, an edit while an approval is in
// flight (release 3.2). The API says why in a sentence, and the sentence is
// what is shown, under a heading that says nothing was changed. No code and no
// support reference: nothing went wrong, and a code on the screen reads as if
// something had.
//
// Anything else is a failure and keeps the ErrorBox, with its code and
// reference for support.

export function RefusalNote({
  error,
  heading,
  what,
  verb,
}: {
  error: unknown
  heading: string
  // For the ErrorBox a failure falls back to.
  what: string
  verb?: string
}) {
  const said = refusalMessage(error)
  if (said === null) return <ErrorBox error={error} what={what} verb={verb} />
  // Shown here, so the feedback net does not add a toast carrying the code.
  markErrorShown(error)
  return (
    <div className="note stop" role="alert" data-testid="refusal-note">
      <strong>{heading}</strong>
      <p style={{ margin: 0 }}>{said}</p>
    </div>
  )
}
